<template>
  <div class="header_box">
    <!-- pc端 -->
    <div class="pc_box">
      <div></div>
      <div class="menu_box">
        <img src="@/assets/newWebSiteImg/common/logo_mini.png" style="width: 220px;cursor: pointer;">
        <div class="px_menu">
          <div @click="toPage('aboutUs')" :style="titleStyle('aboutUs')">关于我们</div>
          <div @click="toPage('solution')" :style="titleStyle('solution')">解决方案</div>
          <div @click="toPage('cooperation')" :style="titleStyle('cooperation')">业务合作</div>
<!--          <div @click="toPage('openApi')" :style="titleStyle('openApi')">开发文档</div>-->
        </div>
        <div style="text-align: right;">
          <b2b-button
            style="width: 100px;height: 40px;line-height: 40px;background-color:#fe8f1d;box-shadow: 0 0 4px rgba(0, 0, 0, .4);"
            @click="toB2B">酒店预订
          </b2b-button>
        </div>
      </div>
      <div style="text-align: center">
        <i class="el-icon-switch-button" style="font-size: 16px;cursor: pointer;" @click="loginOut"
           :style="showLoginOutBtn ? 'visibility: visible' : 'visibility: hidden'"/>
      </div>
    </div>

    <!-- 移动端 -->
    <div class="app_box">

    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {}
  },
  methods: {
    toB2B () {
      if (window.location.hostname == 'localhost') {
        this.$router.push('/NewHome/HomeSearch')
      } else {
        window.open('https://www.zoodian.com/', '_blank')
      }
    },
    toPage (path) {
      this.$router.push(`/view/index/${path}`)
    },
    titleStyle (path) {
      if (this.$route.path.includes(path)) {
        return {
          fontWeight: 'bold'
        }
      }
      return {}
    },
    loginOut () {
      localStorage.removeItem('openApiPartnerInfo')
      this.$router.push('/view/index/aboutUs')
    }
  },
  computed: {
    showLoginOutBtn () {
      return this.$route.path.includes('openApi') && localStorage.getItem('openApiPartnerInfo')
    }
  }
}
</script>

<style lang="less" scoped>
.header_box {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 10;

  // pc端
  @media screen and (min-width: 992px) {
    .pc_box {
      height: 70px;
      background-color: #fff;
      box-shadow: 0 0 1px grey;
      display: block;
      display: grid;
      grid-template-columns: auto 1401px auto;
      align-items: center;

      .menu_box {

        display: grid;
        grid-template-columns: 30% 1fr 30%;
        align-items: center;

        .px_menu {
          cursor: pointer;
          user-select: none;
          width: 75%;
          margin: auto;
          display: grid;
          grid-template-columns: repeat(4, auto);
          //grid-template-columns: repeat(3, auto);
          text-align: center;
          font-size: 16px;
          font-weight: lighter;

          a {
            color: #000;
          }

          /deep/ .router-link-active {
            font-weight: bold;
          }
        }

        /deep/ .b2b_button:hover {
          background-color: #ff9b34 !important;
        }
      }
    }

    .app_box {
      display: none;
    }
  }

  // 移动端
  @media screen and (max-width: 992px) {
    .pc_box {
      display: none;
    }

    .app_box {
      display: block;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/newWebsite/main/components/Header.vue